interface Props {
  step: 1 | 2;
  maxReachedStep: 1 | 2;
  onStepClick: (n: 1 | 2) => void;
}

export function StepIndicator({ step, maxReachedStep, onStepClick }: Props) {
  const dots: (1 | 2)[] = [1, 2];
  return (
    <nav className="step-indicator" aria-label="Eigenes Dokument Fortschritt">
      {dots.map((n, i) => (
        <span key={n} style={{ display: "inline-flex", alignItems: "center" }}>
          <button
            type="button"
            className={[
              "step-dot",
              n <= maxReachedStep ? "active" : "",
              n === step ? "current" : "",
              n > maxReachedStep ? "locked" : "",
            ].filter(Boolean).join(" ")}
            disabled={n > maxReachedStep}
            aria-current={n === step ? "step" : undefined}
            onClick={() => n <= maxReachedStep && onStepClick(n)}
          >
            {n}
          </button>
          {i < dots.length - 1 && <span className="step-line" />}
        </span>
      ))}
    </nav>
  );
}
